import React, { Component } from 'react'


const hasSlidebarRight = ({breakpoint}) =>WrappedComponent => {
    class HasSlidebarRight extends Component {
        constructor(props) {
            super(props)

            this.state = {
                isSlidebarRightOpen: false,
                isMobile: false
            }

            this.breakpoint = {}

            this.onSidebarRightToggle = this.onSidebarRightToggle.bind(this)
            this.breakpointRefreshValue = this.breakpointRefreshValue.bind(this)
            this.updateDimensions = this.updateDimensions.bind(this)
        }

        componentDidMount() {
            this.breakpointRefreshValue()
            this.updateDimensions()
            window.addEventListener("resize", this.updateDimensions)
        }

        componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimension)
        }

        breakpointRefreshValue() {
            this.breakpoint.refreshValue = function () {
                this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
            }
        }

        updateDimensions() {
            this.breakpoint.refreshValue()
            const isMobile = this.getScreenWidthSetting(this.breakpoint.value)

            if(isMobile !== this.state.isMobile) {
                this.setState({
                    isMobile: isMobile,
                })
            }
        }

        getScreenWidthSetting(width) {
            if(width >= breakpoint) {
                return false
            } else {
                return true
            }
        }

        onSidebarRightToggle() {
            this.setState(prevState => ({
                isSlidebarRightOpen: !prevState.isSlidebarRightOpen
            }))
        }

        render() {
            const { isSlidebarRightOpen, isMobile } = this.state
            const displaySidebarRight = isMobile ?  isSlidebarRightOpen : false

            const injectedProps = {
                onSidebarRightToggle: this.onSidebarRightToggle,
                displaySidebarRight: displaySidebarRight,
                isMobile: isMobile
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasSlidebarRight
}

export default hasSlidebarRight